import { render, staticRenderFns } from "./menulateral.vue?vue&type=template&id=7d8b6489&scoped=true"
import script from "./menulateral.vue?vue&type=script&lang=js"
export * from "./menulateral.vue?vue&type=script&lang=js"
import style0 from "./menulateral.vue?vue&type=style&index=0&id=7d8b6489&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8b6489",
  null
  
)

export default component.exports